/* globals jQuery, FJHI */
/* eslint-disable @wordpress/no-global-active-element */

/**
 * External dependencies
 */
import CliboardJS from 'clipboard';

/**
 * Internal dependencies
 */
import delegateEventListener from './theme/delegate-event';
import determineTarget from './theme/determine-target';
import toggleElement from './theme/toggle-element';
import setupStickyObserver from './theme/sticky-observer';
import setupTabs from './theme/tabs';
import setupAccordions from './theme/accordions';
import setupModals from './theme/modals';
import setupCarousels from './theme/carousels';
import setupDropdowns from './theme/dropdown';
import setupShareButtons from './theme/share-button';
import setupDirectoryModules from './theme/ajax-directory';
import setupHeadingObserver from './theme/heading-observer';

jQuery( $ => {
	// =========================
	// ! Flag Interaction Method
	// =========================

	function flagMouseUse() {
		document.body.classList.add( 'using-mouse' );
		document.body.classList.remove( 'using-keyboard' );
	}
	document.addEventListener( 'mousemove', flagMouseUse );
	document.addEventListener( 'touchstart', flagMouseUse );
	document.addEventListener( 'keydown', event => {
		if ( event.key === 'Tab' ) {
			document.body.classList.remove( 'using-mouse' );
			document.body.classList.add( 'using-keyboard' );
		}
	} );

	// =========================
	// ! External Link Mandate
	// =========================

	document.querySelectorAll( 'a[href^="http"]' ).forEach( anchor => {
		if ( ! anchor.target && ! anchor.href.startsWith( window.location.origin ) ) {
			anchor.setAttribute( 'target', '_blank' );
			anchor.setAttribute( 'rel', 'noreferrer noopener' );
		}
	} );

	// =========================
	// ! Basic Toggles
	// =========================

	delegateEventListener( 'click', '.js-toggle', ( event, trigger ) => {
		const target = determineTarget( trigger );
		if ( target ) {
			event.preventDefault();
			const isOpen = toggleElement( target, null, 'focus' );

			// For global styling that might be needed
			document.body.classList.toggle( `show-${ target.id }`, isOpen );
		}
	} );

	delegateEventListener( 'click', '.js-close', ( event, trigger ) => {
		event.preventDefault();
		toggleElement( trigger.closest( '[aria-hidden="false"]' ), false );
	} );

	// =========================
	// ! Intersection Observers
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		setupStickyObserver();

		setupHeadingObserver( 'h3.wp-block-heading[id]', '.fjhi-article' );

		const topMargin = $( 'html' ).css( 'margin-top' ) || '0px';

		const inviewObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				if ( change.intersectionRatio > 0 ) {
					$( change.target ).addClass( 'in-view' );
				}
			} );
		}, {
			margin: `-${ topMargin } 0 0`,
		} );

		$( '.fjhi-grid, .fjhi-grid-cell, .fjhi-scroller, .lazy-load' ).addClass( 'lazy' ).each( function() {
			inviewObserver.observe( this );
		} );
	}

	// =========================
	// ! Modals
	// =========================

	// Add classes to modals automatically
	$( '.fjhi-modal' ).addClass( 'js-modal' );
	$( '.fjhi-modal__close' ).addClass( 'js-modal-close' );
	$( '.fjhi-modal__frame' ).addClass( 'js-modal-backdrop' );

	setupModals( FJHI.endpoints || [] );

	// =========================
	// ! Tab Set
	// =========================

	// Add classes to tab/tabset blocks automatically
	$( '.fjhi-tab-set' ).addClass( 'js-tab-set' );
	$( '.fjhi-tab-set__nav-item' ).addClass( 'js-tab' );
	$( '.fjhi-tab-panel' ).addClass( 'js-tab-panel' );

	// Mark first tab as auto-open accordion
	$( '.fjhi-tab-set' ).each( function() {
		$( this ).find( '.fjhi-tab-header__toggle' ).first().addClass( 'auto-open' );
	} );

	setupTabs();

	// =========================
	// ! Accordion
	// =========================

	// Group adjacent accordions
	$( '.fjhi-accordion' ).each( function() {
		let $group = $( this ).parent( '.fjhi-accordion-group' ) || $( this ).prev( '.fjhi-accordion-group' );
		if ( $group.length === 0 ) {
			$group = $( '<div class="fjhi-accordion-group"></div>' );
			$group.insertBefore( this );
		}

		$( this ).appendTo( $group );
	} );

	// Add classes to accordion blocks automatically
	$( '.fjhi-accordion-group, .fjhi-tab-set' ).addClass( 'js-accordion-group' );
	$( '.fjhi-accordion__toggle, .fjhi-tab-header__toggle' ).addClass( 'js-accordion-toggle' );
	$( '.fjhi-accordion__content, .fjhi-tab-panel' ).addClass( 'js-accordion-content' );

	setupAccordions( FJHI.endpoints || [] );

	// =========================
	// ! Gallery Carousels
	// =========================

	// Prep carousels for functionality
	$( '.fjhi-carousel' ).each( function() {
		$( this ).addClass( 'js-carousel' );
		$( this ).find( '.fjhi-carousel__slides' ).addClass( 'js-carousel-track' )
			.children().addClass( 'js-carousel-slide' );
		$( this ).find( '.fjhi-carousel__pagination' ).addClass( 'js-carousel-pagination' );
	} );

	setupCarousels( { animate: true } );

	// =========================
	// ! Scroller Buttons
	// =========================

	function makeScrollerButton( type ) {
		const button = document.createElement( 'div' );
		button.className = `fjhi-scroller__button ${ type }`;
		const buttonWrapper = document.createElement( 'div' );
		buttonWrapper.className = 'fjhi-scroller__button-wrapper';
		button.setAttribute( 'aria-hidden', true );
		buttonWrapper.append( button );
		return buttonWrapper;
	}

	document.querySelectorAll( '.fjhi-scroller' ).forEach( scroller => {
		const fullWidthItems = scroller.classList.contains( 'full-width-items' );
		const header = scroller.querySelector( '.fjhi-scroller__header' );
		const inner = scroller.querySelector( '.fjhi-scroller__inner' );

		const nav = document.createElement( 'div' );
		nav.classList.add( 'fjhi-scroller__nav' );
		header.append( nav );

		const buttonsBlock = header.querySelector( '.wp-block-buttons:last-child' );
		if ( buttonsBlock ) {
			nav.append( buttonsBlock );
		}

		const nextButtonWrapper = makeScrollerButton( 'next' );
		const prevButtonWrapper = makeScrollerButton( 'prev' );
		nav.append( prevButtonWrapper, nextButtonWrapper );

		const nextButton = nextButtonWrapper.querySelector( '.next' );
		const prevButton = prevButtonWrapper.querySelector( '.prev' );
		const buttons = [ nextButton, prevButton ];

		prevButton.hidden = true;
		inner.addEventListener( 'scroll', () => {
			nextButton.hidden = inner.scrollLeft + inner.offsetWidth >= inner.scrollWidth;
			prevButton.hidden = inner.scrollLeft === 0;
		} );

		const sampleItem = inner.firstElementChild;
		buttons.forEach( button => {
			button.addEventListener( 'click', () => {
				if ( button.hidden ) {
					return;
				}

				const distance = fullWidthItems ? sampleItem.offsetWidth : inner.offsetWidth;

				if ( button.classList.contains( 'next' ) ) {
					inner.scrollBy( {
						left: distance,
					} );
				} else {
					inner.scrollBy( {
						left: -1 * distance,
					} );
				}
			} );
		} );
	} );

	document.addEventListener( 'keyup', event => {
		if ( event.key === 'Tab' ) {
			const scroller = document.activeElement?.closest( '.fjhi-scroller__inner' );
			if ( scroller ) {
				document.activeElement.scrollIntoView( {
					block: 'nearest',
					inline: 'nearest',
				} );
			}
		}
	} );

	// =========================
	// ! Dropdown
	// =========================

	$( '.gfield:has(.ginput_container_select)' ).addClass( 'js-dropdown' );

	setupDropdowns();

	// =========================
	// ! Excerpt Handling
	// =========================

	$( document ).on( 'click', '.js-expand', function() {
		const expanded = $( this ).closest( '.is-expandable' ).toggleClass( 'is-expanded' ).hasClass( 'is-expanded' );

		// Swap the text with the cached label
		const label = $( this ).data( 'label' ) || ( expanded ? 'Show less' : 'Show more' );
		$( this ).data( 'label', $( this ).text() );
		$( this ).text( label );
	} );


	// =========================
	// ! Video Blocks
	// =========================

	$( '.js-video-trigger' ).click( function( e ) {
		e.preventDefault();
		const url = $( this ).data( 'embed' );

		const $iframe = $( `<iframe src="${ url }" frameborder="0" allowfullscreen></iframe>` );

		$( this ).next().remove();
		$iframe.insertAfter( this );
		$( this ).remove();
	} );

	// =========================
	// ! Hidden Target Handling
	// =========================

	function handleHiddenTarget( event ) {
		// Get the target element
		const target = document.getElementById( window.location.hash.substring( 1 ) );
		if ( ! target ) {
			return;
		}

		// See if it's within a hidden container
		const container = target.closest( '[id][aria-hidden="true"]' );
		if ( ! container ) {
			return;
		}

		// Find the control for the container
		const control = document.querySelector( `[aria-controls="${ container.id }"], [data-target="${ container.id }"]` );
		if ( ! control ) {
			return;
		}

		// Prevent automatic scolling
		if ( event ) {
			event.preventDefault();
		}

		// Open the container and focus
		control.click();
		target.scrollIntoView();
	}

	window.addEventListener( 'hashchange', handleHiddenTarget );
	handleHiddenTarget();

	// =========================
	// ! Bookmark/Share Links
	// =========================

	setupShareButtons();

	$( 'a.js-clipboard' ).on( 'click', e => e.preventDefault() );

	const hrefClipboard = new CliboardJS( 'a.js-clipboard', {
		text( trigger ) {
			return trigger.getAttribute( 'href' );
		},
	} );

	const clipboardTooltipTimeouts = new WeakMap();
	hrefClipboard.on( 'success', e => {
		clearTimeout( clipboardTooltipTimeouts.get( e.trigger ) );
		$( e.trigger ).addClass( 'js-copied' ).attr( 'aria-label', 'Link copied!' );
		const timeout = setTimeout( () => $( e.trigger ).removeClass( 'js-copied' ), 5000 );
		clipboardTooltipTimeouts.set( e.trigger, timeout );
	} );

	// =========================
	// ! Directory Module
	// =========================

	setupDirectoryModules();
} );
